import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityActivitiesSettingsRoutes: MenuInterface[] = [

];

